import { ServiceRequest } from "../../api/ServiceRequest";

export class PumpRequest extends ServiceRequest {
  protocol?: number;
  baudRate?: number;
  fuelId?: number;

  constructor(init?: Partial<PumpRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getProtocol(): number | undefined {
    return this.protocol;
  }
  setProtocol(value: number | undefined): void {
    this.protocol = value;
  }

  getBaudRate(): number | undefined {
    return this.baudRate;
  }
  setBaudRate(value: number | undefined): void {
    this.baudRate = value;
  }

  getFuelId(): number | undefined {
    return this.fuelId;
  }
  setFuelId(value: number | undefined): void {
    this.fuelId = value;
  }
}
